const photos = [
    {   
        id: 1,
        picture: require('../imgs/01.jpeg'),
        description: 'Flower',
        tag: 'Nature'
    },
    {
        id: 2,
        picture: require('../imgs/02.jpeg'),
        description: 'Sunset',
        tag: 'Sky'
    },
    {
        id: 3,
        picture: require('../imgs/03.jpeg'),
        description: 'Flower and sunset',
        tag: 'Nature'
    },
    {
        id: 4,
        picture: require('../imgs/04.jpeg'),
        description: 'Flower',
        tag: 'Nature'
    },
    {
        id: 5,
        picture: require('../imgs/05.jpeg'),
        description: 'Sunset',
        tag: 'Road'
    },
    {
        id: 6,
        picture: require('../imgs/06.jpeg'),
        description: 'Flower and sunset',
        tag: 'Nature'
    },
    {
        id: 7,
        picture: require('../imgs/07.jpeg'),
        description: 'Flower',
        tag: 'Sunset'
    },
    {
        id: 8,
        picture: require('../imgs/08.jpeg'),
        description: 'Sunset',
        tag: 'Sky'
    },
    {
        id: 9,
        picture: require('../imgs/09.jpeg'),
        description: 'Flower and sunset',
        tag: 'Nature'
    },
    {
        id: 10,
        picture: require('../imgs/10.jpeg'),
        description: 'Flower and sunset',
        tag: 'Nature'
    },
    {
        id: 11,
        picture: require('../imgs/11.jpeg'),
        description: 'Flower',
        tag: 'Sky'
    },
    {
        id: 12,
        picture: require('../imgs/12.jpeg'),
        description: 'Sunset',
        tag: 'Sky'
    },
    {
        id: 13,
        picture: require('../imgs/13.jpeg'),
        description: 'Flower and sunset',
        tag: 'Sky'
    },
    {
        id: 14,
        picture: require('../imgs/14.jpeg'),
        description: 'Flower',
        tag: 'Nature'
    },
    {
        id: 15,
        picture: require('../imgs/15.jpeg'),
        description: 'Sunset',
        tag: 'Sky'
    },
    {
        id: 16,
        picture: require('../imgs/16.jpeg'),
        description: 'Flower and sunset',
        tag: 'Nature'
    },
    {
        id: 17,
        picture: require('../imgs/17.jpeg'),
        description: 'Flower',
        tag: 'Sunset'
    },
    {
        id: 18,
        picture: require('../imgs/18.jpeg'),
        description: 'Sunset',
        tag: 'Sunset'
    },
    {
        id: 19,
        picture: require('../imgs/19.jpeg'),
        description: 'Flower and sunset',
        tag: 'Nature'
    },
    {
        id: 20,
        picture: require('../imgs/20.jpeg'),
        description: 'Flower and sunset',
        tag: 'Sky'
    },
    {
        id: 21,
        picture: require('../imgs/21.jpeg'),
        description: 'Flower',
        tag: 'Road'
    },
    {
        id: 22,
        picture: require('../imgs/22.jpeg'),
        description: 'Sunset',
        tag: 'Road'
    },
    {
        id: 23,
        picture: require('../imgs/23.jpeg'),
        description: 'Flower and sunset',
        tag: 'Road'
    },
    {
        id: 24,
        picture: require('../imgs/24.jpeg'),
        description: 'Flower',
        tag: 'Sky'
    },
    {
        id: 25,
        picture: require('../imgs/25.jpeg'),
        description: 'Sunset',
        tag: 'Sky'
    },
    {
        id: 26,
        picture: require('../imgs/26.jpeg'),
        description: 'Flower and sunset',
        tag: 'Sky'
    },
    {
        id: 27,
        picture: require('../imgs/27.jpeg'),
        description: 'Flower',
        tag: 'Sky'
    },
    {
        id: 28,
        picture: require('../imgs/28.jpeg'),
        description: 'Sunset',
        tag: 'Cat'
    },
    {
        id: 29,
        picture: require('../imgs/29.jpeg'),
        description: 'Flower and sunset',
        tag: 'Sky'
    },
    {
        id: 30,
        picture: require('../imgs/30.jpeg'),
        description: 'Flower and sunset',
        tag: 'Sky'
    }
]

export default photos;